import { render, staticRenderFns } from "./ChatRoomReport.vue?vue&type=template&id=cb1e56b6&scoped=true"
import script from "./ChatRoomReport.vue?vue&type=script&lang=js"
export * from "./ChatRoomReport.vue?vue&type=script&lang=js"
import style0 from "./ChatRoomReport.vue?vue&type=style&index=0&id=cb1e56b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1e56b6",
  null
  
)

export default component.exports